<template>
  <div class="client-display">
    <div class="px-[4px]">
      <h2>
        <span class="mr-[10px]">心系客户，服务至上</span>
        <img src="/assets/img/icon/handshake.png" width="40" alt=""/>
      </h2>

      <div class="flex flex-col gap-[10px] leading-[1.8] tracking-[2px] text-[18px] text-[#666]">
        <p>
          <b style="color: #0046E4; text-decoration: underline;">
            温州申普经纬科技有限公司</b>成立于2002年，集软件硬件研发、销售和服务为一体的科技型企业。
        </p>
        <p>多年鞋业市场的深入了解和经验累积，我们不断吸取和总结鞋样设计师们的手工经验，
          并实地学习各种鞋类的设计与制作过程，使得申普在产品上不断完善，带给企业更优良的自动化解决方案。</p>

        <p>我们同时秉持着心系客户，服务至上的理念打造我们的服务团队，客户的信任和支持是推动我们前进的最大动力！</p>
      </div>
    </div>

    <ul class="grid">
      <li
        v-for="(item, index) in clients"
        :key="index"
      >
        <img :src="item.img" alt="" />
      </li>
    </ul>
  </div>

  <div class="prod-show flex flex-col gap-[20px] mt-[60px]">
    <button @click="router.push('/cad')">
      <img src="/assets/img/cad/111.png" alt="" />
    </button>

<!--    <ul class="machine-list flex gap-[20px]">-->
<!--      <li-->
<!--        v-for="(item, index) in prods"-->
<!--        :key="index"-->
<!--      >-->
<!--        <ProdItem :data="item" />-->
<!--      </li>-->

<!--&lt;!&ndash;      @click="router.push(`/machine?series=${item.series}`)"&ndash;&gt;-->
<!--    </ul>-->
  </div>
</template>

<script setup lang="ts">
  import clients from "@/assets/client.json"
  import { useI18n } from 'vue-i18n'

  const router = useRouter()
  const { t, locale } = useI18n()

  const prods = [
    {
      name: 'FC-1506 智能裁切机',
      tags: ['震动刀头', '真空吸附'],
      img: '/assets/img/machine/1.png',
      series: '1506'
    },
    {
      name: 'FC-1652 数控放版机',
      tags: ['刀笔双头', '放版打样'],
      img: '/assets/img/machine/2.png',
      series: '1652'
    }
  ]

</script>

<style scoped lang="scss">
  .client-display {
    h2 {
      display: flex;
      align-items: center;
      //justify-content: center;
      gap: 6px;
      margin-bottom: 30px;
      text-align: center;
      font-family: 'SourceHanSans-Bold', sans-serif;
      font-size: 32px;
      font-weight: 600;
    }

    ul {
      grid-template-columns: repeat(4, 1fr);
      border-top: 1px solid #eee;
      border-left: 1px solid #eee;
      margin-top: 40px;
      //height: 200px;

      li {
        border-right: 1px solid #eee;
        border-bottom: 1px solid #eee;
        padding: 20px;
      }
    }
  }

  .prod-show {
    button {
      transition: all ease-in-out .3s;

      &:hover {
        transform: scale(1.04);
        box-shadow: 0 8px 20px rgba(0, 0, 0, .15);
      }
    }
  }

  .machine-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    li {

    }
  }
</style>
